import { ViewCellMap } from "./ViewCellMap";
import { GameWorld } from "../GameWorld";
import { Player } from "../Player/Player";
import { Game, rnd } from "../../../Game";
import { Background } from "../Background/Background";
import { TIMER } from "../../Gameplay";



export class View {
    /**
     * Offset kamery od povrchu zeme na ose Y
     */
    private static readonly CAM_GROUND_OFFSET_Y = 4.5;

    /**
     * Offset kamery od pozice hrace na ose Z
     */
    static readonly CAM_PL_OFFSET_Z = 2.5;

    /**
     * Offset view od pozice kamery na ose Z
     */
    static readonly VIEW_CAM_OFFSET_Z = -0.5;

    /**
     * Jak daleko view vidi (na ose Z)
     */
    static readonly VIEW_DISTANCE = 16;

    /**
     * (RO) Staticky pristup
     */
    static get instance(): View { return View._instance; }
    private static _instance: View;

    private _player: Player;

    /**
     * (RO) Kamera
     */
    get camera(): pc.Entity { return this._camera; }
    private _camera: pc.Entity;

    /**
     * Pozice kamery
     */
    get cameraPos(): pc.Vec3 { return this._cameraPos; }
    private _cameraPos: pc.Vec3;

    /**
     * (RO) Pozice kamery na ose Z
     */
    get cameraZ(): number { return this._cameraPos.z; }

    /**
     * Cas zahajeni zaklepani s obrazem (pokud se obraz neklepe tak < 0)
     */
    private _shakeTime: number;

    /**
     * Pocatecni rozsah vibrace
     */
    private _shakeRange: number;

    /**
     * Delka vibrace v ms
     */
    private _shakeLen: number;

    /**
     * Aktualni pozice view (na ose Z)
     */
    private _viewPos: number;

    /**
     * (RO) Dolni pozice view na ose Z
     */
    get botZ(): number { return this._viewPos; }

    /**
     * (RO) Horni pozice view na ose Z
     */
    get topZ(): number { return this._viewPos - View.VIEW_DISTANCE; }

    /**
     * (RO) Bunkova mapa view
     */
    get cellMap(): ViewCellMap { return this._cellMap; }
    private _cellMap: ViewCellMap;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(player: Player) {
        // Staticky pristup
        View._instance = this;

        // Hrac
        this._player = player;

        // Kamera
        this._camera = new pc.Entity("camera");
        this._camera.addComponent(pc.eCompomentType.camera, {
            fov: 75,
            nearClip: 0.1,
            farClip: 500,
            clearColor: new pc.Color(0, 0, 0),
            frustumCulling: false
        });
        this._camera.camera.layers.push(Background.instance.layer.id);
        this._camera.setEulerAngles(-45, 0, 0);
        Game.app.root.addChild(this._camera);

        this._cameraPos = new pc.Vec3();

        // Bunkova mapa
        this._cellMap = new ViewCellMap();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Pozice kamery
        this._cameraPos.set(GameWorld.CENTER_X, GameWorld.GROUND_Y + View.CAM_GROUND_OFFSET_Y, Player.instance.cameraOrigin.z + View.CAM_PL_OFFSET_Z);
        this._camera.setPosition(this._cameraPos);

        // Vibrace
        this._shakeTime = -1;

        // Pozice view
        this._viewPos = this._cameraPos.z + View.VIEW_CAM_OFFSET_Z;

        // CellMap
        this._cellMap.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    startShake(range: number, len: number): void {
        this._shakeTime = TIMER.time;
        this._shakeRange = range;
        this._shakeLen = len;

        if (rnd.randomBool())
            this._shakeRange *= -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        // Vibrace
        let shakeOffset = 0;

        if (this._shakeTime >= 0) {
            let i = (TIMER.time - this._shakeTime) / this._shakeLen;

            if (i >= 1) {
                i = 1;
                this._shakeTime = -1;
            }

            shakeOffset = this._shakeRange - this._shakeRange * pc.ElasticOut(i);
        }

        // Aktualizovat pozici kamery
        let plPos = this._player.cameraOrigin;
        let dif = plPos.x - GameWorld.CENTER_X;

        this._cameraPos.x = GameWorld.CENTER_X + dif / 2 + shakeOffset;
        this._cameraPos.z = plPos.z + View.CAM_PL_OFFSET_Z;
        this._camera.setPosition(this._cameraPos);

        // Aktualizovat pozici view
        this._viewPos = this._cameraPos.z + View.VIEW_CAM_OFFSET_Z;

        // Aktualizovat mapu
        this._cellMap.update();
    }
}